import { render, staticRenderFns } from "./cat.vue?vue&type=template&id=18c1a169&scoped=true&"
import script from "./cat.vue?vue&type=script&lang=js&"
export * from "./cat.vue?vue&type=script&lang=js&"
import style0 from "./cat.vue?vue&type=style&index=0&id=18c1a169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1a169",
  null
  
)

export default component.exports